<div class="workspace-page container-fluid py-4 px-3 px-md-4 px-lg-5">
  <section class="workspace-page__hero mb-4">
    <h2 class="workspace-page__title mb-0 bw-title-with-info">
      {{ config.title }}
      <app-info-tooltip compact placement="right" [text]="config.description"></app-info-tooltip>
    </h2>
  </section>

  <div class="row g-3 mb-4">
    @for (card of config.cards; track card.title) {
      <div class="col-12 col-xl-4">
        <article class="workspace-page__card h-100 p-4 d-flex flex-column gap-2">
          <h3 class="workspace-page__card-title mb-0">{{ card.title }}</h3>
          <p class="workspace-page__card-copy mb-0">{{ card.description }}</p>
          @if (card.meta) {
            <p class="workspace-page__card-meta mb-0">{{ card.meta }}</p>
          }
        </article>
      </div>
    }
  </div>

  @if (config.highlights?.length) {
    <section class="workspace-page__notes p-4">
      <h3 class="workspace-page__notes-title mb-3">Planned structure</h3>
      <div class="d-grid gap-2">
        @for (highlight of config.highlights; track highlight) {
          <div class="workspace-page__note-item d-flex align-items-start gap-2">
            <span class="workspace-page__note-dot"></span>
            <span>{{ highlight }}</span>
          </div>
        }
      </div>
    </section>
  }
</div>
